module.exports = __webpack_public_path__ + "img/profile-bg.42cc0162.jpg";